export default "__VITE_PUBLIC_ASSET__217c588f__"